// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-text[data-v-50912600] {\n  font-style: normal;\n  font-weight: 300;\n  font-size: 14.4px;\n  color: #1A7BEE;\n}\n.item-holder[data-v-50912600] {\n  border-left: 6px solid transparent;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
